/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { formdocumentation } from './formdocument';

export class formidentification extends IceEntity {
  form_identification_key: string = "";
  code_list_qualifier_code: string = "";
  code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  DOCS: formdocumentation[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAYMENT";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "DOCS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "DOCS") return "FORM_IDENTIFICATION";

    return null;
  }

}
